import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Account = () => {
  const [orders, setOrders] = useState([]);
  const [user, setUser] = useState(null);
  const [openOrders, setOpenOrders] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (!stored) return;

    const parsed = JSON.parse(stored);
    const userData = parsed.user || parsed;
    setUser(userData);

    if (userData?.email) {
      fetch(`/api/orders/${userData.email}`)
        .then((res) => res.json())
        .then((data) => setOrders(Array.isArray(data) ? data : []))
        .catch(() => setOrders([]));
    }
  }, []);

  const toggleDetails = (orderId) => {
    setOpenOrders((prev) => ({ ...prev, [orderId]: !prev[orderId] }));
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  if (!user) {
    return (
      <div className="page">
        <Navbar />
        <section className="section">
          <div className="container">
            <div className="card cardPad">Veuillez vous connecter.</div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page">
      <Helmet>
        <title>Mon compte – Deenzine</title>
        <meta name="description" content="Retrouve tes commandes et informations de compte Deenzine." />
        <link rel="canonical" href={window.location.origin + "/account"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad">
            <h1 className="h2" style={{ color: "var(--brand)" }}>Mon compte</h1>
            <div className="grid" style={{ marginTop: 10 }}>
              <div style={{ gridColumn: "span 6" }}>
                <div className="badge">👤 {user.name}</div>
              </div>
              <div style={{ gridColumn: "span 6" }}>
                <div className="badge">✉️ {user.email}</div>
              </div>
            </div>

            <div className="hr" />

            <h2 className="h2" style={{ fontSize: 20, marginBottom: 8 }}>Mes commandes</h2>

            {orders.length === 0 ? (
              <div className="card cardPad" style={{ boxShadow: "none" }}>
                Vous n’avez pas encore passé de commande.
              </div>
            ) : (
              orders.map((order) => (
                <div key={order.id} className="card cardPad" style={{ marginBottom: 14, boxShadow: "none" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                    <div style={{ fontWeight: 900 }}>
                      Commande #{order.id} • {new Date(order.created_at).toLocaleDateString()}
                    </div>
                    <div className="badge">Total : {Number(order.total).toFixed(2)} €</div>
                  </div>

                  <button className="btn btnSecondary" onClick={() => toggleDetails(order.id)} style={{ marginTop: 12 }}>
                    {openOrders[order.id] ? "Masquer les détails" : "Voir les détails"}
                  </button>

                  {openOrders[order.id] && (
                    <div style={{ marginTop: 14 }}>
                      {(order.items || []).map((item, idx) => (
                        <div key={idx} className="card cardPad" style={{ marginBottom: 12, boxShadow: "none" }}>
                          <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                            <img
                              src={item.image}
                              alt={item.product_name}
                              width="64"
                              height="64"
                              loading="lazy"
                              style={{
                                width: 64,
                                height: 64,
                                objectFit: "cover",
                                borderRadius: 14,
                                border: "1px solid var(--border)",
                              }}
                            />
                            <div style={{ flex: 1 }}>
                              <div style={{ fontWeight: 900 }}>{item.product_name}</div>
                              <div className="p">
                                Couleur : {item.color || "—"} • Quantité : {item.quantity} • Prix : {Number(item.price).toFixed(2)} €
                              </div>
                            </div>
                            <div className="badge">
                              {(Number(item.price) * Number(item.quantity)).toFixed(2)} €
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="card cardPad" style={{ boxShadow: "none" }}>
                        <div style={{ fontWeight: 900, marginBottom: 6 }}>Livraison</div>
                        <div className="p">
                          {order.full_name}<br />
                          {order.address}<br />
                          {order.city}, {order.postal_code}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}

            <button className="btn btnDanger" onClick={handleLogout} style={{ width: "100%", marginTop: 14 }}>
              Se déconnecter
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Account;
